<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6">
        <card title="Create a new page">
          <form @submit.prevent="createPlace">
            <fieldset class="form-group">
              <label for="pageType">Select Page Type</label>
              <select
                id="pageType"
                class="form-control form-control-lg"
                type="text"
                placeholder="name"
                v-model="page.type"
                required
              >
                <option disabled value="">Select page type</option>
                <option v-for="type in pageTypes" :key="type" :value="type">
                  {{ type }}
                </option>
              </select>
            </fieldset>

            <fieldset class="form-group">
              <label for="pageName">Page Name</label>
              <input
                id="pageName"
                class="form-control form-control-lg"
                type="text"
                placeholder="name"
                v-model="page.heading.en"
                required
              />
            </fieldset>
            <fieldset class="form-group">
              <label>Page Description</label>
              <ck-editor v-model="page.description.en"></ck-editor>
            </fieldset>

            <fieldset class="form-group">
              <input
                class="btn btn-primary"
                type="submit"
                value="Create Page"
              />
            </fieldset>
          </form>
        </card>
      </div>
    </div>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { PAGE_PUBLISH } from "@/store/actions.type";
import AssetPreviewBox from '@/components/AssetPreviewBox';
import CkEditor from '@/components/CKEditor';

export default {

  name: "CreatePage",

  components: {
    AssetPreviewBox,
    CkEditor
  },

  data() {
    return {
      page: {
        active: true,
        backgroundImage: "",
        description: {
          en: ''
        },
        heading: {
          en: ''
        },
        minimapImage: "",
        tags: [],
        type: ''
      },
      qrUrl: '',
      qrMessage: '',

      attachedMinimapAsset: {},
      attachedPageBackgroundAsset: {},
      isModalVisible: false,
      modalContext: '',

      pageTypes: [
        'place',
        'events'
      ]
    };
  },

  methods: {
    createPlace() {
      this.$store.dispatch(PAGE_PUBLISH, this.page).then(res => {
        if (res.status === 200) {
          this.$router.push({
            name: "Edit page",
            params: { id: res.data.page._id }
          });
        }
      });
    }
  }
};
</script>
<style lang="scss">

.image-upload {
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 600px;
  width: 100%;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }

  &__preview {
    cursor: pointer;
    padding: 8px;
    position: relative;
    width: 100%;

    @media (min-width: 768px) {
      width: 400px;
    }

    .preview-image-wrapper {
      background: #000;
      border-radius: 4px;
      height: 100%;
      overflow: hidden;
      position: relative;
      transition: all 200ms ease-in-out;
      width: 100%;

      &:hover {

        .preview-image {
          opacity: .9;
          transform: scale(1.03);
        }

        .preview-icon {
          transform: translate(-50%, -50%) scale(1.5);
        }
      }
    }

    .preview-image {
      object-fit: cover;
      transform: scale(1.01);
      transition: all 200ms ease-in-out;
      opacity: 1;
      width: 100%;

      &--not-selected {
        align-items: center;
        color: #fff;
        display: flex;
        height: 100%;
        justify-content: center;
        min-height: 100px;
      }
    }

    .preview-icon {
      color: #fff;
      font-size: 20px;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%) scale(1);
      transition: all 200ms ease-in-out;
      z-index: 1;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 8px;
    width: 100%;

    @media (min-width: 768px) {
      padding: 8px 8px 8px 0;
      width: 200px;
    }

    .image-details {

      &__wrapper {
        margin-bottom: 10px;
      }

      &__label {
        font-size: 14px;
        font-weight: 500;
      }

      &__value {
        font-size: 12px;
        font-weight: 400;
        opacity: .8;
      }
    }
  }
}
</style>
